"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.graphColorPalette = exports.APUtilisationStackedBarChart = void 0;
var _reactChartjs = require("react-chartjs-2");
var _react = _interopRequireDefault(require("react"));
var _chart = require("chart.js");
var _chartjsPluginDatalabels = _interopRequireDefault(require("chartjs-plugin-datalabels"));
var _auto = _interopRequireDefault(require("chart.js/auto"));
var _patternomaly = _interopRequireDefault(require("patternomaly"));
var _chartjsPluginAnnotation = _interopRequireDefault(require("chartjs-plugin-annotation"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var graphColorPalette = ['#1E8777', '#3E8CC1', '#3C8C51', '#C5602C', '#00B8A3', '#1743E6', '#3C8C51', '#235D85', '#c4c4c4', '#8EC3BB', '#9EC5E0', '#9DC5A8', '#E2AF95', '#80DBD1', '#8BA1F3', '#9DC5A8', '#91AEC2', '#E1E1E1', '#D2E7E4', '#D8E8F3', '#D8E8DC', '#F3DFD5', '#CCF1ED', '#D1D9FA', '#D8E8DC', '#D3DFE7', '#F3F3F3'];
exports.graphColorPalette = graphColorPalette;
var APUtilisationStackedBarChart = function APUtilisationStackedBarChart(_ref) {
  var chartData = _ref.chartData,
    limit = _ref.limit,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 150 : _ref$height,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 900 : _ref$width,
    _ref$barThickness = _ref.barThickness,
    barThickness = _ref$barThickness === void 0 ? 35 : _ref$barThickness,
    _ref$striped = _ref.striped,
    striped = _ref$striped === void 0 ? false : _ref$striped,
    _ref$showLegend = _ref.showLegend,
    showLegend = _ref$showLegend === void 0 ? true : _ref$showLegend,
    _ref$showTooltip = _ref.showTooltip,
    showTooltip = _ref$showTooltip === void 0 ? false : _ref$showTooltip,
    _ref$alwaysShowLabel = _ref.alwaysShowLabel,
    alwaysShowLabel = _ref$alwaysShowLabel === void 0 ? false : _ref$alwaysShowLabel,
    _ref$anchorPosition = _ref.anchorPosition,
    anchorPosition = _ref$anchorPosition === void 0 ? 'end' : _ref$anchorPosition,
    _ref$hideLabels = _ref.hideLabels,
    hideLabels = _ref$hideLabels === void 0 ? false : _ref$hideLabels,
    _ref$groupSmallItems = _ref.groupSmallItems,
    groupSmallItems = _ref$groupSmallItems === void 0 ? false : _ref$groupSmallItems,
    _ref$remainingText = _ref.remainingText,
    remainingText = _ref$remainingText === void 0 ? 'Remaining' : _ref$remainingText;
  _auto["default"].register(_chartjsPluginAnnotation["default"]);
  var SMALL_LIMIT = 1;
  var stripBackground = function stripBackground(color) {
    function lighterColor(color) {
      var parts = color.replace('#', '').split(/(.{2})/).filter(function (p) {
        return !!p;
      });
      var lighterParts = parts.map(function (part) {
        var s = Math.ceil(parseInt(part, 16) * 0.6).toString(16);
        s = '00'.substring(0, 2 - s.length) + s;
        return s;
      });
      return '#' + _toConsumableArray(lighterParts).join('');
    }
    return _patternomaly["default"].draw('diagonal-right-left', color, lighterColor(color), 8);
  };
  var barBackgroundColor = '#EEEDEE';
  var defaultStack = 'defaulStack';
  var getMax = function getMax(rawData, utilisationLimit) {
    var _rawData$at2;
    var utilisedAmount = rawData.reduce(function (partialSum, a) {
      return partialSum + a.value;
    }, 0);
    if (utilisedAmount === utilisationLimit && rawData.length === 1) {
      var _rawData$at;
      return utilisationLimit - ((rawData === null || rawData === void 0 ? void 0 : (_rawData$at = rawData.at(0)) === null || _rawData$at === void 0 ? void 0 : _rawData$at.value) || 0) + 2;
    }
    return utilisationLimit - ((rawData === null || rawData === void 0 ? void 0 : (_rawData$at2 = rawData.at(0)) === null || _rawData$at2 === void 0 ? void 0 : _rawData$at2.value) || 0);
  };
  var getMin = function getMin(rawData) {
    var _rawData$at3;
    return -((rawData === null || rawData === void 0 ? void 0 : (_rawData$at3 = rawData.at(0)) === null || _rawData$at3 === void 0 ? void 0 : _rawData$at3.value) || 1);
  };
  var mapDataToChartData = function mapDataToChartData(rawData, utilisationLimit) {
    var dataLabelOptions = {
      display: function display(context) {
        if (hideLabels) {
          return false;
        }
        if (alwaysShowLabel) {
          return true;
        }
        return context.datasetIndex !== rawData.length - 1 ? 'auto' : true;
      },
      anchor: anchorPosition,
      align: 'top',
      textAlign: 'end',
      color: graphColorPalette[0],
      clamp: true,
      clip: false,
      formatter: function formatter(v) {
        return Math.abs(v) + '%';
      },
      font: {
        lineHeight: 1.3
      },
      padding: {
        bottom: barThickness / 3 * 2
      }
    };
    var dataSetTemplate = {
      data: [0],
      backgroundColor: graphColorPalette[0],
      barThickness: barThickness,
      borderRadius: 10,
      borderSkipped: undefined,
      label: '',
      stack: defaultStack,
      datalabels: dataLabelOptions,
      rawValue: undefined,
      labelDesc: undefined
    };
    var dataSetRemainingTemplate = {
      data: [0],
      backgroundColor: barBackgroundColor,
      barThickness: barThickness,
      borderRadius: 10,
      borderSkipped: undefined,
      label: undefined,
      borderColor: barBackgroundColor,
      stack: defaultStack,
      datalabels: {
        display: false
      },
      rawValue: undefined,
      labelDesc: undefined
    };

    // add each item
    var dataItems = rawData.map(function (item, index) {
      var result = _objectSpread({}, dataSetTemplate);

      // special handle for the graph to display the first item
      result.rawValue = item.value;
      result.data = index === 0 ? [-item.value] : [item.value];
      result.data = result.data[0] === 0 ? [] : result.data; // Skip Items with value 0

      if (item.value < SMALL_LIMIT && groupSmallItems) {
        result.data = []; // Skip small items
      }

      result.backgroundColor = item.color || graphColorPalette.at(index % graphColorPalette.length) || '';
      if (result.datalabels) {
        var dataLabelsOptions = _objectSpread({}, result.datalabels);
        dataLabelsOptions.color = item.color || graphColorPalette.at(index % graphColorPalette.length) || '';
        result.datalabels = dataLabelsOptions;
      }
      if (striped) {
        result.backgroundColor = stripBackground(result.backgroundColor);
      }
      result.label = item.label;
      result.labelDesc = item.labelDesc;
      return result;
    });

    // calculate and add remaining
    var utilisedAmount = rawData.reduce(function (partialSum, a) {
      return partialSum + a.value;
    }, 0);
    var remaingDataItem = _objectSpread({}, dataSetRemainingTemplate);
    var remainingValue = utilisationLimit - utilisedAmount;
    remaingDataItem.data = remainingValue >= 0 ? [remainingValue] : [0];
    remaingDataItem.rawValue = remainingValue;

    // Handle 1 item with empty utilisation
    if (remainingValue === 100) {
      remaingDataItem.borderSkipped = false;
    }
    dataItems.push(remaingDataItem);

    // Handle 1 item with full utilisation
    if (remainingValue <= 0 && rawData.length === 1) {
      dataItems[0].borderSkipped = false;
    }
    var data = {
      labels: [''],
      datasets: dataItems
    };
    return data;
  };
  var mappedData = mapDataToChartData(chartData, limit);
  var smallItems = mappedData.datasets.filter(function (item) {
    var newItem = item;
    if (newItem.rawValue === undefined) {
      return false;
    }
    return newItem.rawValue < SMALL_LIMIT;
  });

  // @ts-ignore https://www.chartjs.org/docs/latest/configuration/tooltip.html#custom-position-modes
  _chart.Tooltip.positioners.custom = function (elements, eventPosition) {
    return {
      x: eventPosition.x,
      y: eventPosition.y
    };
  };

  // Custom Tooltip
  // https://www.chartjs.org/docs/latest/samples/tooltip/html.html
  var getOrCreateTooltip = function getOrCreateTooltip(chart) {
    var tooltipEl = chart.canvas.parentNode.querySelector('div');
    if (!tooltipEl) {
      tooltipEl = document.createElement('div');
      tooltipEl.style.background = 'rgb(0, 0, 0)';
      tooltipEl.style.borderRadius = '4px';
      tooltipEl.style.color = 'white';
      tooltipEl.style.opacity = 1;
      tooltipEl.style.pointerEvents = 'none';
      tooltipEl.style.position = 'absolute';
      tooltipEl.style.transform = 'translate(-50%, 0)';
      tooltipEl.style.transition = 'all .1s ease';
      tooltipEl.style.minWidth = 'fit-content';
      tooltipEl.style.zIndex = '2000';
      var table = document.createElement('table');
      table.style.margin = '0px';
      tooltipEl.appendChild(table);
      chart.canvas.parentNode.appendChild(tooltipEl);
    }
    return tooltipEl;
  };
  var getTooltipContent = function getTooltipContent(items) {
    var tableBody = document.createElement('tbody');
    items.forEach(function (item, i) {
      var tr = document.createElement('tr');
      tr.style.backgroundColor = 'inherit';
      tr.style.borderWidth = '0px';
      tr.style.fontSize = '13px';
      var td = document.createElement('td');
      td.style.borderWidth = '0px';
      td.style.display = 'flex';
      td.style.flexDirection = 'row';
      td.style.margin = '8px';
      td.style.borderRight = '1px solid #EAEAEA';
      td.style.paddingRight = '16px';

      // Grid
      var bigGrid = document.createElement('div');
      bigGrid.style.background = item.backgroundColor;
      bigGrid.style.borderColor = item.borderColor;
      bigGrid.style.borderWidth = '2px';
      bigGrid.style.marginRight = '10px';
      bigGrid.style.borderRadius = '8px';
      bigGrid.style.height = '36px';
      bigGrid.style.width = '36px';
      bigGrid.style.display = 'inline-block';
      td.appendChild(bigGrid);
      var text = document.createTextNode(item.label || remainingText);
      td.style.verticalAlign = 'middle';
      var descText = document.createTextNode("(".concat(item.labelDesc, ")"));
      var textSpan = document.createElement('div');
      textSpan.style.height = '36px';
      textSpan.style.fontWeight = '400';
      textSpan.style.verticalAlign = 'middle';
      textSpan.appendChild(text);
      textSpan.style.minWidth = '60px';
      var descTextSpan = document.createElement('span');
      descTextSpan.style.fontWeight = '300';
      if (item.labelDesc) {
        var br = document.createElement('br');
        textSpan.appendChild(br);
        descTextSpan.appendChild(descText);
      } else {
        textSpan.style.lineHeight = '38px';
      }
      var td2 = document.createElement('td');
      td2.style.borderWidth = '0px';
      td2.style.padding = '8px';
      td2.style.fontWeight = '300';
      var staticText = document.createTextNode(item.value);
      td2.appendChild(staticText);
      textSpan.appendChild(descTextSpan);
      td.appendChild(textSpan);
      tr.appendChild(td);
      tr.appendChild(td2);
      tableBody.appendChild(tr);
    });
    return tableBody;
  };
  var externalTooltipHandler = function externalTooltipHandler(context) {
    var _tooltip$title;
    if (!showTooltip) {
      return;
    }
    // Tooltip Element
    var chart = context.chart,
      tooltip = context.tooltip;
    var shouldShowSmallItemsSummary = false;
    if (((_tooltip$title = tooltip.title) === null || _tooltip$title === void 0 ? void 0 : _tooltip$title.length) === 0) {
      // This is the last item
      if (groupSmallItems && smallItems.length > 0) {
        shouldShowSmallItemsSummary = true;
      }
    }
    var tooltipEl = getOrCreateTooltip(chart);

    // Hide if no tooltip
    if (tooltipEl && tooltip.opacity === 0) {
      tooltipEl.style.opacity = 0;
      return;
    }

    // Set Body
    if (tooltip.body) {
      var bodyLines = tooltip.body.map(function (b) {
        return b.lines;
      });
      var tableHead = document.createElement('thead');
      var tableBody = document.createElement('tbody');
      if (!shouldShowSmallItemsSummary) {
        var items = bodyLines.map(function (body, i) {
          var _tooltip$labelColors$, _tooltip$dataPoints$, _tooltip$dataPoints$2;
          var colors = (_tooltip$labelColors$ = tooltip.labelColors[i]) !== null && _tooltip$labelColors$ !== void 0 ? _tooltip$labelColors$ : '';
          return {
            backgroundColor: colors.backgroundColor,
            borderColor: colors.borderColor,
            label: (_tooltip$dataPoints$ = tooltip.dataPoints[0].dataset.label) !== null && _tooltip$dataPoints$ !== void 0 ? _tooltip$dataPoints$ : '',
            labelDesc: (_tooltip$dataPoints$2 = tooltip.dataPoints[0].dataset.labelDesc) !== null && _tooltip$dataPoints$2 !== void 0 ? _tooltip$dataPoints$2 : '',
            value: tooltip.dataPoints[0].dataset.rawValue + '%'
          };
        });
        tableBody = getTooltipContent(items);
      } else {
        if (tooltip.body) {
          var _items = smallItems.map(function (smallItem, i) {
            var item = smallItem;
            return {
              backgroundColor: item.backgroundColor,
              borderColor: item.borderColor,
              label: item.label || '',
              labelDesc: item.labelDesc || '',
              value: '<' + SMALL_LIMIT + '%'
            };
          });
          tableBody = getTooltipContent(_items);
        }
      }
      var tableRoot = tooltipEl.querySelector('table');

      // Remove old children
      while (tableRoot.firstChild) {
        tableRoot.firstChild.remove();
      }

      // Add new children
      tableRoot.appendChild(tableHead);
      tableRoot.appendChild(tableBody);
    }
    var _chart$canvas = chart.canvas,
      positionX = _chart$canvas.offsetLeft,
      positionY = _chart$canvas.offsetTop;

    // Display, position, and set styles for font
    tooltipEl.style.opacity = 1;
    tooltipEl.style.left = positionX + tooltip.caretX + 'px';
    tooltipEl.style.top = positionY + tooltip.caretY + 'px';
    tooltipEl.style.font = tooltip.options.bodyFont.string;
    tooltipEl.style.padding = tooltip.options.padding + 'px ' + tooltip.options.padding + 'px';
  };
  var options = {
    animation: {
      duration: 400
    },
    maintainAspectRatio: false,
    indexAxis: 'y',
    layout: {
      padding: {
        right: 14,
        left: 14
      }
    },
    plugins: {
      legend: {
        display: showLegend,
        position: 'bottom',
        align: 'start',
        labels: {
          filter: function filter(item, chart) {
            return !!item.text;
          },
          boxWidth: 12
        },
        onClick: function onClick(e) {
          var _e$native;
          return (_e$native = e["native"]) === null || _e$native === void 0 ? void 0 : _e$native.stopPropagation();
        }
      },
      tooltip: {
        enabled: false,
        yAlign: 'top',
        xAlign: 'center',
        padding: 10,
        external: externalTooltipHandler,
        // @ts-ignore https://www.chartjs.org/docs/latest/configuration/tooltip.html#custom-position-modes
        position: 'custom',
        callbacks: {
          title: function title(context) {
            if (!context.length) {
              return '';
            }
            return context[0].dataset.label || '';
          },
          label: function label(item) {
            if (!item) {
              return '';
            }
            var dataset = item.dataset;
            var desc = dataset.labelDesc ? " (".concat(dataset.labelDesc, ")") : '';
            return Math.abs(item.raw) + '%' + desc;
          }
        }
      }
    },
    scales: {
      y: {
        position: 'center',
        display: false,
        grid: {
          display: false
        }
      },
      x: {
        position: 'top',
        min: getMin(chartData),
        max: getMax(chartData, limit),
        display: false,
        grid: {
          display: false
        },
        stacked: true,
        beginAtZero: false
      }
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: "".concat(width, "px"),
      height: "".concat(height, "px")
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactChartjs.Bar, {
    data: mappedData,
    options: options,
    plugins: [_chartjsPluginDatalabels["default"]]
  }));
};
exports.APUtilisationStackedBarChart = APUtilisationStackedBarChart;